<template>
  <div class="new-app-page">
    <section class="content">
      <div class="content-center">

        <div class="logo">
          <pidz-logo-blue />
        </div>

        <h2>Onze app is vernieuwd</h2>
        
        <p>
          Alles vind je voortaan in onze nieuwe PIDZ app.
        </p>
        
        <p>
          Onze nieuwe app is beschikbaar in de Appstore & Google Playstore.
        </p>
        
        <div class="badges">
          <a v-if="isIosOrWeb" href="https://apps.apple.com/nl/app/pidz/id6747712718"
             target="_blank" >
            <app-store-badge />
          </a>
          <a v-if="isAndroidOrWeb" href="https://play.google.com/store/apps/details?id=com.pidzsoftware.pidzzorgplatform"
             target="_blank" >
            <play-store-badge />
          </a>
        </div>
      </div>

      <div class="bottom">
        Tijdelijk zijn alleen je facturen uit 2025 en eerder nog in deze app in te zien.
        <button class="back-button" @click="goToInvoices">
          Facturen bekijken
        </button>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import AppStoreBadge from '@app/components/AppStoreBadge.vue';
import PidzLogoBlue from '@app/components/PidzLogoBlue.vue';
import PlayStoreBadge from '@app/components/PlayStoreBadge.vue';
import { Capacitor } from '@capacitor/core';
import { computed } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();

const goToInvoices = () => {
  router.push({ name: 'invoices' });
};

const isIosOrWeb = computed(() => Capacitor.getPlatform() === 'ios' || Capacitor.getPlatform() === 'web');
const isAndroidOrWeb = computed(() => Capacitor.getPlatform() === 'android' || Capacitor.getPlatform() === 'web');
</script>

<style lang="scss" scoped>
.new-app-page {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;

  .content {
    padding: 24px 16px;
    width: 100%;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: auto;

    .content-center {
      flex-grow: 1;
    }

    .logo {
      display: flex;
      justify-content: center;
      margin-bottom: 24px;

      .pidz-logo {
        height: 40px;
        width: auto;
      }
    } 

    h2 {
      color: var(--pidz-blue);
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      margin-bottom: 16px;
    }

    p {
      color: var(--pidz-black);
      font-size: 16px;
      line-height: 1.5;
      margin-bottom: 16px;
      text-align: center;
    }

    .badges {
      display: flex;
      justify-content: center;
      gap: 16px;
      margin-bottom: 32px;

      a {
        display: block;
        height: 50px;

        svg {
          height: 100%;
          width: auto;
        }
      }
    }

    .bottom {
      margin-top: auto;
      text-align: center;
      padding-bottom: calc(24px + env(safe-area-inset-bottom));

      .back-button {
        border: 0;
        margin-top: 16px;
        font-family: inherit;
        color: var(--pidz-white);
        display: block;
        width: 100%;
        padding: 12px;
        font-size: 16px;
        background-color: var(--pidz-blue);
        text-align: center;
        border-radius: 5px;
        cursor: pointer;

        &:hover {
          opacity: 0.9;
        }
      }
    }
  }
}
</style>
